/* Özel eklenti: ürün sayfasında "Tükenmek üzere" rozetini
   seçili varyanta göre göster/gizle.
   Impulse, varyant değişiminde section kabı üzerinde
   'variantChange' CustomEvent'i tetikler. */
(function () {
  function initSection(container) {
    var badge = container.querySelector('[data-low-stock-badge]');
    var dataEl = container.querySelector('[data-low-stock-data]');
    if (!badge || !dataEl) return;

    var inventory;
    try {
      inventory = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var threshold = parseInt(badge.getAttribute('data-threshold'), 10);
    if (isNaN(threshold)) threshold = 2;

    container.addEventListener('variantChange', function (evt) {
      var variant = evt.detail && evt.detail.variant;
      if (!variant) {
        badge.hidden = true;
        return;
      }
      var info = inventory[variant.id];
      badge.hidden = !(info && info.a === true && info.q > 0 && info.q <= threshold);
    });
  }

  function boot() {
    var sections = document.querySelectorAll('.product-section');
    for (var i = 0; i < sections.length; i++) initSection(sections[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
